import type { ReactNode } from 'react';
import { AppShell } from '@mantine/core';
import { Footer } from './Footer';
import { Header } from './Header';
import { useActiveSection } from '../../hooks/useActiveSection';

interface LayoutProps {
  children: ReactNode;
  isAuthenticated?: boolean;
}

export function Layout({ children, isAuthenticated = false }: LayoutProps) {
  const { section } = useActiveSection();

  // Fixed header height - no more secondary nav
  const headerHeight = 70;

  return (
    <AppShell header={{ height: headerHeight }} padding={0}>
      <AppShell.Header>
        <Header isAuthenticated={isAuthenticated} activeSection={section?.id} />
      </AppShell.Header>

      <AppShell.Main>
        <div style={{ minHeight: `calc(100vh - ${headerHeight}px - 200px)` }}>
          {children}
        </div>
        <Footer />
      </AppShell.Main>
    </AppShell>
  );
}
